module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.pageModeText))]), _vm._v(" "), _c('el-button', {
    staticClass: "back",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goPromotionList
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper"
  }, [_c('el-form', {
    ref: "promoFormRef",
    staticStyle: {
      "min-width": "1200px"
    },
    attrs: {
      "label-width": "110px",
      "label-position": "left",
      "model": _vm.promoForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称",
      "required": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "placeholder": "请输入活动名称（最多20个字）",
      "maxlength": 20,
      "disabled": _vm.isView
    },
    model: {
      value: (_vm.promoForm.name),
      callback: function($$v) {
        _vm.$set(_vm.promoForm, "name", $$v)
      },
      expression: "promoForm.name"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tip-text"
  }, [_vm._v("（最多20个字，不允许重复）")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "促销时间",
      "required": ""
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "placeholder": "开始时间至结束时间",
      "disabled": _vm.isLocked
    },
    model: {
      value: (_vm.promoForm.timeRange),
      callback: function($$v) {
        _vm.$set(_vm.promoForm, "timeRange", $$v)
      },
      expression: "promoForm.timeRange"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tip-text"
  }, [_vm._v("\n          结束时间须 ≥ 开始时间；开始时间须 ≥ 当前系统时间\n        ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "适用会员卡",
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "placeholder": "请选择已发布的售卖卡",
      "disabled": _vm.isLocked
    },
    on: {
      "change": _vm.onCardChange
    },
    model: {
      value: (_vm.promoForm.cardId),
      callback: function($$v) {
        _vm.$set(_vm.promoForm, "cardId", $$v)
      },
      expression: "promoForm.cardId"
    }
  }, _vm._l((_vm.cardOptions), function(card) {
    return _c('el-option', {
      key: card.id,
      attrs: {
        "label": ((card.name) + "（ID:" + (card.id) + "）"),
        "value": card.id
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.selectedCard) ? _c('el-form-item', {
    attrs: {
      "label": "卡片信息"
    }
  }, [_c('div', {
    staticClass: "card-info"
  }, [_c('span', [_vm._v("卡ID：" + _vm._s(_vm.selectedCard.id))]), _vm._v(" "), (_vm.selectedCard.type === 3) ? _c('span', [_vm._v("会员卡生效时间：" + _vm._s(_vm.$dayjs(_vm.selectedCard.effectiveStartTime).format("YYYY-MM-DD")) + "\n            至\n            " + _vm._s(_vm.$dayjs(_vm.selectedCard.effectiveEndTime).format("YYYY-MM-DD")))]) : _c('span', [_vm._v("会员卡时长：" + _vm._s(_vm.selectedCard.duration) + " 天")]), _vm._v(" "), _c('span', [_vm._v("是否自动续费：" + _vm._s(_vm.autoRenewText))]), _vm._v(" "), _c('span', [_vm._v("售卖价格：" + _vm._s(_vm.cardPriceText))])])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动限制"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "disabled": _vm.isLocked
    },
    model: {
      value: (_vm.promoForm.limitType),
      callback: function($$v) {
        _vm.$set(_vm.promoForm, "limitType", $$v)
      },
      expression: "promoForm.limitType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不限制",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "每个用户限购1次",
      "value": 2
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "促销方案",
      "required": ""
    }
  }, [_c('div', {
    staticClass: "scheme-block"
  }, [(!_vm.isLocked && _vm.promoForm.schemes.length === 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.addScheme
    }
  }, [_vm._v("添加规则")]) : [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.promoForm.schemes,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "适用人群",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(row.crowdText))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "topTag",
      "label": "顶部标签",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "tag-input",
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "placeholder": "选填，最多6个字符",
            "disabled": _vm.isView
          },
          on: {
            "change": function (e) { return _vm.handleInput(e, 6, scope); }
          },
          model: {
            value: (scope.row.topTag),
            callback: function($$v) {
              _vm.$set(scope.row, "topTag", $$v)
            },
            expression: "scope.row.topTag"
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "tip-text",
          class: {
            tipsRed: scope.row['error-topTag']
          }
        }, [_vm._v("\n                    " + _vm._s(_vm.topTagCount) + " / 6\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bottomTag",
      "label": "底部标签",
      "min-width": "240"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-radio-group', {
          staticClass: "bottom-tag-type",
          attrs: {
            "disabled": _vm.isView
          },
          model: {
            value: (scope.row.bottomTagType),
            callback: function($$v) {
              _vm.$set(scope.row, "bottomTagType", $$v)
            },
            expression: "scope.row.bottomTagType"
          }
        }, [_c('el-radio', {
          attrs: {
            "label": 1
          }
        }, [_vm._v("文字内容")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": 2
          }
        }, [_vm._v("活动倒计时")])], 1), _vm._v(" "), (scope.row.bottomTagType === 2) ? [_c('div', {
          staticClass: "fixed-tag-text"
        }, [_vm._v("按促销时间显示倒计时")])] : [_c('el-input', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "placeholder": "选填，最多8个字符",
            "disabled": _vm.isView
          },
          on: {
            "change": function (e) { return _vm.handleInput(e, 8, scope); }
          },
          model: {
            value: (scope.row.bottomTag),
            callback: function($$v) {
              _vm.$set(scope.row, "bottomTag", $$v)
            },
            expression: "scope.row.bottomTag"
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "tip-text",
          class: {
            tipsRed: scope.row['error-bottomTag']
          }
        }, [_vm._v("\n                      " + _vm._s(_vm.bottomTagCount) + " / 8\n                    ")])]]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "促销价",
      "min-width": "280"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-radio-group', {
          attrs: {
            "disabled": _vm.isLocked
          },
          model: {
            value: (row.priceType),
            callback: function($$v) {
              _vm.$set(row, "priceType", $$v)
            },
            expression: "row.priceType"
          }
        }, [_c('el-radio', {
          attrs: {
            "label": "price"
          }
        }, [_vm._v("价格")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": "discount"
          }
        }, [_vm._v("折扣")])], 1), _vm._v(" "), _c('div', {
          staticClass: "price-input-row"
        }, [(row.priceType === 'price') ? [_c('el-input-number', {
          staticStyle: {
            "width": "160px"
          },
          attrs: {
            "min": 0.01,
            "max": 9999,
            "step": 0.01,
            "disabled": _vm.isLocked
          },
          model: {
            value: (row.price),
            callback: function($$v) {
              _vm.$set(row, "price", $$v)
            },
            expression: "row.price"
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "tip-text"
        }, [_vm._v("元（0.01~9999，最多2位小数）")])] : [_c('el-input-number', {
          staticStyle: {
            "width": "120px"
          },
          attrs: {
            "min": 1,
            "max": 99,
            "step": 1,
            "disabled": _vm.isLocked
          },
          model: {
            value: (row.discount),
            callback: function($$v) {
              _vm.$set(row, "discount", $$v)
            },
            expression: "row.discount"
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "tip-text"
        }, [_vm._v("%（1~99 整数）")]), _vm._v(" "), (_vm.computedDiscountPrice != null) ? _c('span', {
          staticClass: "computed-price"
        }, [_vm._v("促销价：¥" + _vm._s(_vm.computedDiscountPrice))]) : _vm._e()]], 2)]
      }
    }])
  })], 1)]], 2)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动说明"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "560px"
    },
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": _vm.isView,
      "placeholder": "请输入活动说明（选填）"
    },
    model: {
      value: (_vm.promoForm.description),
      callback: function($$v) {
        _vm.$set(_vm.promoForm, "description", $$v)
      },
      expression: "promoForm.description"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }, [(!_vm.isView) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickPublish
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? "保存" : "发布"))]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a802fdb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/UserAdminister/MemberPromotion/MemberPromotionDetail.vue
// module id = 1012
// module chunks = 0